const validateSubmitNewsForm = async (values: any) => {
  const errors: {
    [key: string]: string;
  } = {};

  if (!values.title) {
    errors.title = "Title is required";
  }

  if (!values.intro) {
    errors.intro = "Intro is required";
  } else if (values.intro.length < 10) {
    errors.excerpt = "Excerpt must be at least 10 characters long";
  }

  if (!values.content || values.content.trim().length === 0) {
    errors.content = "Content is required";
  }

  if (!values.imageURL) {
    errors.imageURL = "Image is required for all news";
  }

  return Object.entries(errors).length === 0 ? undefined : errors;
};

export default validateSubmitNewsForm;
